import React from 'react';
import { Grid } from '@material-ui/core';

import { FormUser } from 'views/User/components';
import { useStyles } from './styles';

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container spacing={4}>
        <Grid item lg={8} md={11} xl={8} xs={12} className={classes.grid}>
          <FormUser />
        </Grid>
      </Grid>
    </div>
  );
};
